import { FinancialInstitutionDto, LoanControllerApi } from 'client';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import React from 'react'
import { useHistory } from 'react-router-dom';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useFinancialInstitutionServices = () => {
    const history = useHistory();
    const loanServices = new LoanControllerApi();
    const token = getTokenFromStorage();
    const [financialInstitutions, setFinancialInstitutions] = React.useState<FinancialInstitutionDto[]>();

    const errorRedirect = () => {
        history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
    };

    const getFinancialInstitutions = () => {
        loanServices.fetchFinancialInstitutionUsingGET(token)
            .then((response) => setFinancialInstitutions(response.data))
            .catch((_err) => errorRedirect());
    }

    return { getFinancialInstitutions, financialInstitutions } as const;
}
